import { AuthEffects } from './auth/authentication.effects';
import { CreateUserEffects } from './users/users.effects';
import { SurveyEffects } from './survey/survey.effects';
export const effects = [
  AuthEffects,
  CreateUserEffects,
  SurveyEffects,
];
